import { useStore } from "@/store";
import { flashWarning } from "@/utils";

export const fetchPremedicinering = async ({ query }: { query?: string } = {}) => {
    const store = useStore();

    try {
        const params: { q?: string } = {};

        if (query) {
            params.q = query;
        }

        const { subsetName } = await store.dispatch("operation/premedicinering/fetchPremedicinering", {
            filterParams: params,
            displayMode: true,
        });

        return store.getters["operation/premedicinering/premedicineringSubset"]({
            subsetName,
            displayMode: true,
            offset: 0,
        });
    } catch (error) {
        flashWarning("Kunde inte hämta premedicinering");
    }
};
